var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hero-section",class:{ big: _vm.inLobby }},[_c('div',{staticClass:"hero-bg-img h-100 d-flex align-items-end justify-content-center position-relative",style:({
      background: _vm.getBackgroundImage(_vm.heroBgClass, _vm.$store.state.locale),
    })},[(_vm.heroContentComponent)?[_c(_vm.heroContentComponent,{tag:"component"})]:_vm._e(),(_vm.hasHeroNav)?[_c('HeroNav',{attrs:{"content-type":_vm.heroBgClass}})]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }